import axiosInstance from "../utils/axios";

export const GetCoursesToLink = async (values, cancelToken) => {
  return await axiosInstance().post(`/getCoursesToLink`, values, {
    cancelToken: cancelToken
    
  });
};

export const FetchAssessmentDetails = async (id, intake) => {
  return await axiosInstance().get(`fetch-assessment?assessment_id=${id}&intake=${intake}`);
}

export const GetAssessmentsData = async (intake, assId) => {
  return await axiosInstance().get("get-assessments-data", {params: {intake, assId}});
}

export const AddAssessment = async (data) => {
  return await axiosInstance().post("/add-assessment/", data);
}

export const SendAssessmentInstruction = async (data) => {
  return await axiosInstance().post("sendAssignmentInstuction", data);
}
export const getOverrideAssessments = async (data) => {
  return await axiosInstance().post(`/getOverrideAssessments`, data );
};